import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/pricing-excise/pricing-rate-table')({
  staticData: toStaticData(CRT_ROUTES['/crt/pricing-excise/pricing-rate-table']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
